import JSCookie from 'js-cookie';

type CookieAttributes = NonNullable<Parameters<typeof JSCookie.set>[2]>;

export const getCookie = (key: string) => JSCookie.get(key);

export const deleteCookie = (key: string) => JSCookie.remove(key);

export const setCookie = (
  key: string,
  value: string = key,
  additionalParams?: CookieAttributes
) => JSCookie.set(key, value, { expires: 1, ...additionalParams });
